declare global {
  interface Window {
    gtag: any
  }
}


export function trackEvent(eventName: string, params: any) {
  if (window.gtag) {
    window.gtag(
      'event',
      eventName,
      params
    );
  }
}
